import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import { crmCustomersLoadAll, customerSearch } from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(crmCustomersLoadAll.type, send, socket);
  yield takeEvery(customerSearch.type, send, socket);
}
